import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface CommonData {
    id: number;
    name: string;
    cnt: number;
}

interface Summary {
    view_cnt: number;
    weather: number;
    message_cnt: number;
    subscribe_cnt: number;
}

interface Recommend {
    channel_id: string;
    channel_title: string;
    photo: string;
    recommend_gb: string;
}

interface PopStock {
    isu_srt_cd: string;
    isu_kor_abbrv: string;
}

interface MainState {
    sectors: CommonData[];
    categories: CommonData[];
    corps: CommonData[];
    summaries: Summary;
    popstocks: PopStock[];
    recommend: Recommend[];
}

const initialState: MainState = {    
    sectors: [],
    categories: [],
    corps: [],
    summaries: {
        view_cnt: 0,
        weather: null,
        message_cnt: 0,
        subscribe_cnt: 0,
    },
    popstocks: [],
    recommend: [],
};

const mainSlice = createSlice({
    name: "main",
    initialState,
    reducers: {
        setSectors: (state, action: PayloadAction<CommonData[]>) => {
            state.sectors = action.payload;
        },
        setCategories: (state, action: PayloadAction<CommonData[]>) => {
            state.categories = action.payload;
        },
        setCorps: (state, action: PayloadAction<CommonData[]>) => {
            state.corps = action.payload;
        },
        setSummaries: (state, action: PayloadAction<Summary>) => {
            state.summaries = action.payload;
        },
        setPopStocks: (state, action: PayloadAction<PopStock[]>) => {
            state.popstocks = action.payload;
        },
        setRecommend: (state, action: PayloadAction<Recommend[]>) => {
            state.recommend = action.payload;
        },
    },
});

export const transformApiData = (data: any) => {
    return {
        sectors: data?.sectors?.map((item: any) => ({
            id: item.sector_id,
            name: item.sector_name,
            cnt: item.cnt
        })) || [],

        categories: data?.categories?.map((item: any) => ({
            id: item.category_id,
            name: item.category_name,
            cnt: item.cnt
        })) || [],

        corps: data?.corps?.map((item: any) => ({
            id: item.corp_id,
            name: item.corp_name,
            cnt: item.cnt
        })) || [],
    };
};

export const { setSectors, setCategories, setCorps, setSummaries, setPopStocks, setRecommend } = mainSlice.actions;
export default mainSlice.reducer;
